<div [style.padding]="dialog ? '0' : '0 24px 64px 24px'" class="mat-typography tier-details-root" [class.dialog-mode]="dialog">
    <kiene-page-header
        *ngIf="!dialog"
        [routeRelativeAlternative]="'../../'"
        [ueberschrift]="'Tierdetails'"
    ></kiene-page-header>

    <div *ngIf="isLoading" style="display: flex; align-items: center; justify-content: center">
        <mat-hint [style.padding]="dialog ? '24px 0 ' : '128px 0 0 0'" class="hinweis-text" style="text-align: center">
            Lade Tierdaten...
        </mat-hint>
    </div>

    <div *ngIf="!isLoading && tier">
        <div>
            <div class="details-headline" id="heading">
                <h3>Übersicht</h3>
            </div>

            <div id="content">
                <div class="details-item">
                    <strong>Ohrmarke:</strong>
                    <span>{{ tier?.ohrmarke_notnull }}</span>
                </div>

                <div class="details-item">
                    <strong>Gruppe:</strong>
                    <span>{{ tier?.gruppe }}</span>
                </div>

                <div class="details-item">
                    <strong>Geschlecht:</strong>
                    <span>{{ tier?.geschlecht || noValue }}</span>
                </div>

                <div class="details-item">
                    <strong>Rasse:</strong>
                    <span>{{ tier?.rasse || noValue }}</span>
                </div>

                <div class="details-item">
                    <strong>Einstalldatum:</strong>
                    <span>{{ (tier?.einstalldatum_notnull | date: "dd.MM.yyyy") || noValue }}</span>
                </div>

                <div class="details-item">
                    <strong>Geburtsdatum:</strong>
                    <span>{{ (tier?.geburtsdatum | date: "dd.MM.yyyy") || noValue }}</span>
                </div>

                <div *ngIf="tier?.todesdatum_notnull" class="details-item">
                    <strong>Todesdatum:</strong>
                    <span>{{ (tier?.todesdatum_notnull | date: "dd.MM.yyyy") || noValue }}</span>
                </div>

                <div class="details-item">
                    <strong>Alter Tage:</strong>
                    <span class="details-item--no-space">
                        <span>{{ tier?.alter_tage || noValue }}</span>
                        <span *ngIf="tier?.alter_tage">&nbsp;Tage</span>
                    </span>
                </div>
                <div class="details-item">
                    <strong>Alter Wochen:</strong>
                    <span class="details-item--no-space">
                        <span>{{ tier?.alter_wochen || noValue }}</span>
                        <span *ngIf="tier?.alter_wochen">&nbsp;Wochen</span>
                    </span>
                </div>
                <div class="details-item">
                    <strong>In VetVet erfasst:</strong>
                    <span>{{ (tier?.erstellt | date: "dd.MM.yyyy") || noValue }}</span>
                </div>

                <div *ngIf="tier?.sgs > 0" class="details-item">
                    <strong>Schlachttermin:</strong>
                    <span>{{ (tier?.schlachtgrenze | date: "dd.MM.yyyy") || noValue }}</span>
                </div>

                <div *ngIf="tier?.tierliste_id > 0" class="details-item">
                    <strong>Tierliste:</strong>
                    <span>(#{{ tier?.tierliste_id }}) {{ tier?.tierliste_kommentar }}</span>
                </div>

                <div class="details-item">
                    <strong>IDs:</strong>
                    <span>GT:{{ tier?.gt_id }} / T:{{ tier?.tier_id }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="dialog" style="padding: 6px 0">
            <mat-divider style="width: 100%"></mat-divider>
        </div>

        <div>
            <div class="details-headline" id="heading">
                <h3>Herkunfts betrieb</h3>
                <button
                    *kienePermission="[11014]"
                    mat-icon-button
                    (click)="openHerkunftBearbeiten()"
                    class="edit-button"
                    title="Herkunftsbetrieb bearbeiten"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </div>

            <div id="content">
                <div class="details-item">
                    <strong>VVVO:</strong>
                    <span>{{ tier?.herkunft_vvvo }}</span>
                </div>
                <div class="details-item">
                    <strong>Betrieb:</strong>
                    <span>{{ tier?.herkunft_betrieb }}</span>
                </div>
                <div class="details-item">
                    <strong>Stra&szlig;e:</strong>
                    <span>{{ tier?.herkunft_strasse }}</span>
                </div>
                <div class="details-item">
                    <strong>PLZ Ort:</strong>
                    <span>{{ tier?.herkunft_plz }} {{ tier?.herkunft_ort }}</span>
                </div>
                <div class="details-item">
                    <strong>Ortsteil:</strong>
                    <span>{{ tier?.herkunft_ort }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="dialog" style="padding: 6px 0">
            <mat-divider style="width: 100%"></mat-divider>
        </div>

        <ng-container *ngIf="zeigeGewichte()">
            <div>
                <div class="details-headline" id="heading">
                    <h3>Gewichte</h3>
                </div>

                <div id="content">
                    <div class="details-item">
                        <strong>Einstallgewicht:</strong>
                        <span>{{ bioWert(tier?.einstallgewicht, 'kg') }}</span>
                    </div>
                    <div class="details-item">
                        <strong>Ausstallgewicht:</strong>
                        <span>{{ bioWert(tier?.ausstallgewicht, 'kg') }}</span>
                    </div>
                    <div class="details-item">
                        <strong>Schlachtung Lebendgewicht:</strong>
                        <span>{{ bioWert(tier?.hit_lebendgewicht, 'kg') }}</span>
                    </div>
                    <div class="details-item">
                        <strong>Schlachtgewicht:</strong>
                        <span>{{ bioWert(tier?.hit_schlachtgewicht, 'kg') }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </ng-container>
        <ng-container *ngIf="zeigePreise()">
            <div>
                <div class="details-headline" id="heading">
                    <h3>Preise</h3>
                </div>

                <div id="content">
                    <div class="details-item">
                        <strong>Preis Einstallung:</strong>
                        <span>{{ bioWert(tier?.kp_einstallpreis, '€') }}</span>
                    </div>

                    <div class="details-item">
                        <strong>Preis Ausstallung:</strong>
                        <span>{{ bioWert(tier?.kp_abgangspreis, '€') }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </ng-container>
        <ng-container *ngIf="zeigeEinkauf()">
            <div>
                <div class="details-headline" id="heading">
                    <h3>Einkauf</h3>
                </div>

                <div id="content">
                    <div class="details-item">
                        <strong>EK Brutto:</strong>
                        <span>{{ bioWert(tier?.ek_brutto, '€') }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </ng-container>
        <ng-container *kienePermission="[9161]">
            <div>
                <div class="details-headline" id="heading">
                    <h3>Schlachtdaten</h3>
                </div>

                <div id="content">
                    <div class="details-item">
                        <strong>Schlachtnummer:</strong>
                        <span>{{ tier?.hit_schlachtnummer || noValue }}</span>
                    </div>

                    <div class="details-item">
                        <strong>Schlachtdatum:</strong>
                        <span>{{ (tier?.hit_schlachtdatum | date: "dd.MM.yyyy") || noValue }}</span>
                    </div>
                    <div class="details-item">
                        <strong>Schlachthof:</strong>
                        <span>{{ tier?.schlachthof || noValue }}</span>
                    </div>
                    <div class="details-item">
                        <strong>Schlachthof VVVO:</strong>
                        <span>{{ tier?.schlachthof_vvvo || noValue }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </ng-container>

        <ng-container *kienePermission="[9601, 9132]">
            <div>
                <div class="details-headline">
                    <h3>Kontakte</h3>
                    <div class="header-actions">
                        <ng-container *ngIf="tier?.betriebskontakt_haendler_id">
                            <button
                                (click)="removeBetriebskontaktHaendler()"
                                *kienePermission="[9132]"
                                color="warn"
                                mat-icon-button
                                matTooltip="Kontakt entfernen"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </ng-container>
                        <button
                            (click)="openBetriebskontaktHaendlerHinzufuegen()"
                            *kienePermission="[9132]"
                            color="accent"
                            mat-icon-button
                            matTooltip="Kontakt hinzufügen/ändern"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Betriebskontakt-Händler Anzeige -->
                <div class="details-item">
                    <div
                        *ngIf="
                            tier?.betriebskontakt_haendler_id && betriebskontaktHaendler && !isLoadingBetriebskontakt
                        "
                        class="betriebskontakt-haendler-display"
                    >
                        <kiene-betriebskontakt-card
                            [kontakt]="betriebskontaktHaendler"
                            [config]="{
                                showActions: false,
                                showMenu: false,
                                showFavorit: false,
                                showBadge: true,
                                compact: true,
                                selectedMode: false
                            }"
                        >
                        </kiene-betriebskontakt-card>
                    </div>
                    <div *ngIf="isLoadingBetriebskontakt" class="loading-haendler">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Lade Kontakt-Daten...</span>
                    </div>
                    <div *ngIf="!tier?.betriebskontakt_haendler_id" class="no-haendler">
                        <span>{{ noValue }}</span>
                    </div>
                </div>
            </div>

            <!-- Legacy Händler Abschnitt -->
            <div>
                <div class="details-headline">
                    <h3>Händler</h3>
                    <div class="header-actions">
                        <ng-container *ngIf="tier?.viehhaendler_id">
                            <button
                                (click)="removeViehhaendler()"
                                *kienePermission="[9132]"
                                color="warn"
                                mat-icon-button
                                matTooltip="Händler entfernen"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        </ng-container>
                        <button
                            (click)="openViehhaendlerHinzufuegen()"
                            *kienePermission="[9132]"
                            color="accent"
                            mat-icon-button
                            matTooltip="Händler hinzufügen/ändern"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>

                <!-- Legacy Händler Anzeige als Betriebskontakt-Card -->
                <div class="betriebskontakt-haendler-display">
                    <div *ngIf="legacyHaendlerAsBetriebskontakt && !isLoadingLegacyHaendler">
                        <kiene-betriebskontakt-card
                            [kontakt]="legacyHaendlerAsBetriebskontakt"
                            [config]="{
                                showActions: false,
                                showMenu: false,
                                showFavorit: false,
                                showBadge: false,
                                compact: false,
                                selectedMode: false
                            }"
                        >
                        </kiene-betriebskontakt-card>
                    </div>
                    <div *ngIf="isLoadingLegacyHaendler" class="loading-haendler">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Lade Händler-Daten...</span>
                    </div>
                    <div *ngIf="!tier?.viehhaendler_id" class="no-haendler">
                        <span>{{ noValue }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </ng-container>
        <div>
            <div>
                <h3>HIT-Meldung</h3>
            </div>

            <table style="width: 100%">
                <tr>
                    <td><strong>Einstallen:</strong></td>
                    <td>
                        <strong>{{ tier?.status_id_einstallen === 143 ? tier.hit_fehler_einstallen : "" }}</strong>
                    </td>
                    <td>
                        <mat-icon [ngClass]="getIconStatusClass(tier?.status_id_einstallen)">
                            {{ getIcon(tier?.status_id_einstallen) }}
                        </mat-icon>
                    </td>
                </tr>

                <tr>
                    <td><strong>Abgang:</strong></td>
                    <td>
                        <strong>{{ tier?.status_id_abgang === 143 ? tier.hit_fehler_abgang : "" }}</strong>
                    </td>
                    <td>
                        <mat-icon [ngClass]="getIconStatusClass(tier?.status_id_abgang)">
                            {{ getIcon(tier?.status_id_abgang) }}
                        </mat-icon>
                    </td>
                </tr>

                <tr>
                    <td><strong>Tod:</strong></td>
                    <td>
                        <strong>{{ tier?.status_id_tod === 143 ? tier.hit_fehler_tod : "" }}</strong>
                    </td>
                    <td>
                        <mat-icon [ngClass]="getIconStatusClass(tier?.status_id_tod)">
                            {{ getIcon(tier?.status_id_tod) }}
                        </mat-icon>
                    </td>
                </tr>
            </table>
        </div>

        <div *ngIf="dialog" style="padding: 6px 0">
            <mat-divider style="width: 100%"></mat-divider>
        </div>

        <ng-container *kienePermission="[9231, 9232]">
            <div>
                <div class="details-headline">
                    <h3>Reklamationen</h3>
                    <button
                        (click)="openTierreklamationHinzufuegen()"
                        *kienePermission="[9232]"
                        color="accent"
                        mat-icon-button
                    >
                        <mat-icon>add</mat-icon>
                    </button>
                </div>

                <div class="details-item">
                    <div *ngIf="tier?.reklamationen?.length > 0" class="details-item--list">
                        <div *ngFor="let reklamation of tier?.reklamationen">
                            <mat-icon color="accent" style="transform: scale(0.75); padding-right: 6px">
                                comment
                            </mat-icon>
                            <span>&bdquo;{{ reklamation.reklamation }}&ldquo;</span>
                        </div>
                    </div>
                    <div *ngIf="tier?.reklamationen?.length === 0">
                        <span>{{ noValue }}</span>
                    </div>
                </div>
            </div>

            <div *ngIf="dialog && tier?.pdf_id_pass" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </ng-container>
        <div *ngIf="tier?.pdf_id_pass">
            <h3 style="margin-block-end: 0">Pass PDF</h3>

            <kiene-pdf-viewer-component
                [pdfViewerInput]="pdfViewerInput"
                style="margin: 0 -12px"
            ></kiene-pdf-viewer-component>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>

            <div *ngIf="dialog" style="padding: 6px 0">
                <mat-divider style="width: 100%"></mat-divider>
            </div>
        </div>
    </div>
</div>
